import { User } from "@/utils/user";
import api from "@/api/api";
import { useDispatch } from "react-redux";
import { setUser } from "@/state/user/userSlice";
import { useQuery } from "@tanstack/react-query";

async function me(): Promise<User> {
  const res = await api.get("/api/v1/me");
  return res.data.data;
}

const API_BASE_URL = import.meta.env.VITE_API_URL || "";

export const useMe = (token?: string) => {
  const dispatch = useDispatch();

  const me = useQuery(["me", "user"], async () => {
    const headers: HeadersInit = token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {};

    const res = await api.get(`${API_BASE_URL}/api/v1/me`, { headers });

    return res.data.data;
  });

  if (token) {
    if (me.isSuccess && me.data) {
      dispatch(setUser(me.data));
    } else {
      dispatch(setUser(null));
    }
  }

  return me;
};

export default me;
